"use client";

import React from "react";
import { SidebarDropdownNavItem } from "./SidebarDropdownNavItem";
import { SidebarLinkNavItem } from "./SidebarLinkNavItem";
import { SidebarNavDropdownItem, SidebarNavItem, SidebarNavSection } from "./SidebarNav.types";
import { SidebarSectionLabel } from "./SidebarSectionLabel";
import { SidebarSubNavItem } from "./SidebarSubNavItem";
import { SidebarGroup, SidebarGroupContent, SidebarMenu, SidebarMenuSub } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

type SidebarNavSectionsProps = {
  sections: SidebarNavSection[];
  pathname: string;
  collapsed: boolean;
  onNavigate: (item: SidebarNavItem | SidebarNavDropdownItem) => void;
};

export const SidebarNavSections: React.FC<SidebarNavSectionsProps> = ({
  sections,
  pathname,
  collapsed,
  onNavigate,
}) => {
  return (
    <>
      {sections.map((section, index) => (
        <SidebarGroup key={section.label} className={cn("gap-1 py-0", collapsed ? "px-0.5" : "px-2")}>
          {!collapsed && (
            <div className="px-3">
              <SidebarSectionLabel>{section.label}</SidebarSectionLabel>
            </div>
          )}
          {collapsed && index > 0 && <div className="h-px bg-cede-border/30 mx-2 my-1" />}
          <SidebarGroupContent className={cn("py-1", collapsed ? "px-0.5" : "px-2 ")}>
            <SidebarMenu>
              {section.items.map((item) => {
                const visibleSubItems = item.subItems?.filter((sub) => !sub.hidden);

                if (item.dropdownItems && item.dropdownItems.length > 0) {
                  return (
                    <SidebarDropdownNavItem
                      key={item.label}
                      item={item}
                      collapsed={collapsed}
                      onNavigate={onNavigate}
                    />
                  );
                }

                return (
                  <React.Fragment key={item.label}>
                    <SidebarLinkNavItem item={item} collapsed={collapsed} pathname={pathname} onNavigate={onNavigate} />
                    {visibleSubItems && visibleSubItems.length > 0 && (
                      <SidebarMenuSub>
                        {visibleSubItems.map((subItem) => (
                          <SidebarSubNavItem
                            key={subItem.label}
                            item={subItem}
                            collapsed={collapsed}
                            pathname={pathname}
                            onNavigate={onNavigate}
                          />
                        ))}
                      </SidebarMenuSub>
                    )}
                  </React.Fragment>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      ))}
    </>
  );
};
